// ** Third Party Imports
import { Heading, Typography } from '@/shared/ui'
import styled from 'styled-components'

export const ChoosePlanWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 60%;
	row-gap: 2rem;
	border-radius: 1rem;
	background: white;
	box-shadow: 0px 2px 8px 0px #096a6340;
	padding: 2rem 2rem;

	@media (max-width: 1024px) {
		flex-direction: column;
		row-gap: 1.5rem;
	}

	& .logout {
		width: fit-content;
	}
`

export const StyledHeading = styled(Heading)`
	text-align: center;
	color: ${({ theme }) => theme.pallette.text.black75};
`

export const StyledTypography = styled(Typography)`
	text-align: center;
	color: ${({ theme }) => theme.pallette.text.black75};
`
